import { Skeleton } from '@/components/ui/skeleton';
import { FirmGridSkeleton, FirmDetailsSkeleton, TableSkeleton, StatGridSkeleton } from './index';

const Shell = ({ children }: { children: React.ReactNode }) => (
  <div className="min-h-screen bg-background pt-20">
    <div className="container mx-auto px-4 py-8 space-y-8">{children}</div>
  </div>
);

export const HomePageSkeleton = () => (
  <div className="min-h-screen bg-background">
    <div className="pt-24 pb-16 container mx-auto px-4 space-y-6 text-center">
      <Skeleton className="h-12 w-3/4 max-w-2xl mx-auto" />
      <Skeleton className="h-6 w-2/3 max-w-xl mx-auto" />
      <div className="flex justify-center gap-3 pt-4">
        <Skeleton className="h-12 w-36 rounded-xl" />
        <Skeleton className="h-12 w-36 rounded-xl" />
      </div>
    </div>
    <div className="container mx-auto px-4 space-y-12 pb-16">
      <Skeleton className="h-72 w-full rounded-2xl" />
      <Skeleton className="h-96 w-full rounded-2xl" />
      <Skeleton className="h-72 w-full rounded-2xl" />
    </div>
  </div>
);

export const ListPageSkeleton = () => (
  <Shell>
    <Skeleton className="h-10 w-72" />
    <Skeleton className="h-5 w-96" />
    <Skeleton className="h-14 w-full rounded-xl" />
    <FirmGridSkeleton count={8} />
  </Shell>
);

export const DetailPageSkeleton = () => <FirmDetailsSkeleton />;

export const TablePageSkeleton = () => (
  <Shell>
    <Skeleton className="h-10 w-64" />
    <StatGridSkeleton count={4} />
    <div className="grid md:grid-cols-[260px_1fr] gap-6">
      <Skeleton className="h-96 rounded-xl hidden md:block" />
      <TableSkeleton rows={10} cols={7} />
    </div>
  </Shell>
);

export const DefaultPageSkeleton = () => (
  <Shell>
    <Skeleton className="h-10 w-2/3 max-w-md" />
    <Skeleton className="h-5 w-full max-w-2xl" />
    <div className="space-y-3 pt-4">
      {Array.from({ length: 8 }).map((_, i) => (
        <Skeleton key={i} className="h-4 w-full" />
      ))}
    </div>
    <Skeleton className="h-64 w-full rounded-2xl" />
  </Shell>
);
